import TemplateRenderer from "../templates/TemplateRenderer";

export default function Home() {
    return <TemplateRenderer />;
}
